import *as utils from '../utils'
import { get, post } from './index'
import {applicationName} from "../utils";



//新增来源 
export const addResource =(param, callBack) => {
   post("/cm-sites-" + applicationName()+`/sourceController/addSource`, {time: new Date().getTime(),...param}, callBack)
}

//修改来源
export const editResource =(param, callBack) => {
    post("/cm-sites-" + applicationName()+`/sourceController/updateSource`, {time: new Date().getTime(),...param}, callBack)
}

//查询来源
export const getResource =(param, callBack) => {
    get("/cm-sites-" + applicationName()+`/sourceController/pageListSource`, {time: new Date().getTime(),...param}, callBack)
}

//删除来源
export const delResource =(param, callBack) => {
    post("/cm-sites-" + applicationName()+`/sourceController/deleteSource`, {time: new Date().getTime(),...param}, callBack)
}

